// extracted by mini-css-extract-plugin
module.exports = {"paymentTermsWrapper":"payment-term_paymentTermsWrapper___pktm","sectionNameWrapper":"payment-term_sectionNameWrapper__tKd5y"};